
import React, { useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CustomizableAvatar from "../common/CustomizableAvatar";
import MainAvatar from "../../assets/main-avatar.png";
import Smartlend from "../../assets/SMARTLEND.png";
import { DragAndDropIcon, SkipIcon } from "../common/IconComponents";
import axios from "axios";

const UploadLogo = () => {
  const navigate = useNavigate();

  const [dragActive, setDragActive] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [logoLink, setLogoLink] = useState("");
  const inputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files);
    }
  };

  const location = useLocation();
  const email = location.state?.email || "";

  const onButtonClick = async () => {
    if (uploadedImage) {
      try {
        // Make API request to verify logo link
        const response = await axios.post(
          "https://smartapp-lendbackend.onrender.com/api/admin/signup/verify-logo",
          { logoLink } // Send the logo link in the payload
        );

        // Handle the API response
        console.log("API response", response.data);

        // Navigate to "/verifyEmail" route on successful submission
        navigate("/verifyEmail");
      } catch (error) {
        // Handle any errors that occurred during the API request
        console.error("API error", error);
        alert(error.response.data);
      }
    } else {
      alert("Please upload an image before completing sign up.");
    }
  };

  const handleFile = (files) => {
    const file = files[0];

    // Create a FormData object
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "eqprvodt");

    // Make an HTTP request to Cloudinary using Axios
    axios
      .post("https://api.cloudinary.com/v1_1/darnus3nl/image/upload", formData)
      .then((response) => {
        // Handling response from Cloudinary
        console.log(response.data);
        // Extracting image URL from the response
        const imageUrl = response.data.secure_url;
        setUploadedImage(imageUrl);

        // Set the logo link to the image URL
        setLogoLink(imageUrl);
      })
      .catch((error) => {
        console.error("Error uploading image to Cloudinary: ", error);
      });
  };

  return (
    <main>
      <section className="container my-0 mx-auto">
        <section>
          <CustomizableAvatar
            src={Smartlend}
            avatarClass="lg:hidden my-0 mx-auto py-2"
          />
          <div className="p-4 px-4 md:p-8">
            <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
              <CustomizableAvatar
                src={MainAvatar}
                customClass="px-1 lg:min-h-max"
              />

              <div className="px-10 lg:col-span-2 py-5">
                <CustomizableAvatar
                  src={Smartlend}
                  avatarClass="hidden lg:block text-2xl"
                />
                <p className="text-xl sm:text-2xl font-medium py-6">
                  Upload company logo
                </p>
                <p>
                  Give your workspace a more pleasing feel with your company
                  logo
                </p>

                <form
                  id="form-file-upload"
                  onDragEnter={handleDrag}
                  onSubmit={(e) => e.preventDefault()}
                  className="w-9/12 pt-4"
                >
                  <input
                    ref={inputRef}
                    type="file"
                    id="input-file-upload"
                    multiple={false}
                    onChange={handleChange}
                    className="hidden"
                  />
                  <label
                    id="label-file-upload"
                    htmlFor="input-file-upload"
                    className={`flex items-center justify-center h-full border rounded bg-th-bg text-center py-11 px-8 ${dragActive ? "bg-white" : ""
                      }`}
                  >
                    {uploadedImage ? (
                      <img
                        src={uploadedImage}
                        alt="Uploaded"
                        className="max-h-64 max-w-full"
                      />
                    ) : (
                      <div>
                        <button
                          className="cursor-pointer border-none p-0.5 bg-transparent"
                          onClick={() => inputRef.current.click()}
                        >
                          <DragAndDropIcon />
                        </button>
                        <p>Drag and drop or select from your device</p>
                      </div>
                    )}
                  </label>
                  {dragActive && (
                    <div
                      className="absolute w-full h-full rounded top-0 right-0 left-0 bottom-0"
                      onDragEnter={handleDrag}
                      onDragLeave={handleDrag}
                      onDragOver={handleDrag}
                      onDrop={handleDrop}
                    ></div>
                  )}

                  <div className="flex items-center justify-between mt-6">
                    <button
                      className="px-14 py-1 rounded bg-enabled-btn text-white"
                      onClick={onButtonClick}
                      type="button"
                    >
                      Complete sign up
                    </button>

                    <Link
                      to={"/verifyEmail"}
                      className="flex items-center text-enabled-btn text-xs"
                    >
                      skip <SkipIcon className="pl-1" />
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </section>
    </main>
  );
};

export default UploadLogo;


// YOUR CODE UNTOUCHED - 2
// import React, { useState, useRef } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import CustomizableAvatar from "../common/CustomizableAvatar";
// import MainAvatar from "../../assets/main-avatar.png";
// import Smartlend from "../../assets/SMARTLEND.png";
// import { DragAndDropIcon, SkipIcon } from "../common/IconComponents";
// import axios from "axios";

// const UploadLogo = () => {
//   const navigate = useNavigate();

//   const [dragActive, setDragActive] = useState(false);
//   const [uploadedImage, setUploadedImage] = useState(null);
//   const inputRef = useRef(null);

//   const handleDrag = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     if (e.type === "dragenter" || e.type === "dragover") {
//       setDragActive(true);
//     } else if (e.type === "dragleave") {
//       setDragActive(false);
//     }
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setDragActive(false);
//     if (e.dataTransfer.files && e.dataTransfer.files[0]) {
//       handleFile(e.dataTransfer.files);
//     }
//   };

//   const handleChange = (e) => {
//     e.preventDefault();
//     if (e.target.files && e.target.files[0]) {
//       handleFile(e.target.files);
//     }
//   };

//   const location = useLocation();
//   const email = location.state?.email || "";

//   const onButtonClick = async () => {
//     if (uploadedImage) {
//       try {
//         // Make API request to verify email
//         const response = await axios.post(
//           "https://smartapp-lendbackend.onrender.com/api/admin/signup/verify-email",
//           { email }
//         );

//         // Handle the API response
//         console.log("API response", response.data);

//         // Navigate to "/verifyEmail" route on successful submission
//         navigate("/verifyEmail");
//       } catch (error) {
//         // Handle any errors that occurred during the API request
//         console.error("API error", error);
//         alert(error.response.data);
//       }
//     } else {
//       alert("Please upload an image before completing sign up.");
//     }
//   };

//   const handleFile = (files) => {
//     const file = files[0];

//     // Create a FormData object
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("upload_preset", "eqprvodt");

//     // Make an HTTP request to Cloudinary using Axios
//     axios
//       .post("https://api.cloudinary.com/v1_1/darnus3nl/image/upload", formData)
//       .then((response) => {
//         // Handling response from Cloudinary
//         console.log(response.data);
//         // Extracting image URL from the response
//         const imageUrl = response.data.secure_url;
//         setUploadedImage(imageUrl);
//       })
//       .catch((error) => {
//         console.error("Error uploading image to Cloudinary: ", error);
//       });
//   };

//   return (
//     <main>
//       <section className="container my-0 mx-auto">
//         <section>
//           <CustomizableAvatar
//             src={Smartlend}
//             avatarClass="lg:hidden my-0 mx-auto py-2"
//           />
//           <div className="p-4 px-4 md:p-8">
//             <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
//               <CustomizableAvatar
//                 src={MainAvatar}
//                 customClass="px-1 lg:min-h-max"
//               />

//               <div className="px-10 lg:col-span-2 py-5">
//                 <CustomizableAvatar
//                   src={Smartlend}
//                   avatarClass="hidden lg:block text-2xl"
//                 />
//                 <p className="text-xl sm:text-2xl font-medium py-6">
//                   Upload company logo
//                 </p>
//                 <p>
//                   Give your workspace a more pleasing feel with your company
//                   logo
//                 </p>

//                 <form
//                   id="form-file-upload"
//                   onDragEnter={handleDrag}
//                   onSubmit={(e) => e.preventDefault()}
//                   className="w-9/12 pt-4"
//                 >
//                   <input
//                     ref={inputRef}
//                     type="file"
//                     id="input-file-upload"
//                     multiple={false}
//                     onChange={handleChange}
//                     className="hidden"
//                   />
//                   <label
//                     id="label-file-upload"
//                     htmlFor="input-file-upload"
//                     className={`flex items-center justify-center h-full border rounded bg-th-bg text-center py-11 px-8 ${
//                       dragActive ? "bg-white" : ""
//                     }`}
//                   >
//                     {uploadedImage ? (
//                       <img
//                         src={uploadedImage}
//                         alt="Uploaded"
//                         className="max-h-64 max-w-full"
//                       />
//                     ) : (
//                       <div>
//                         <button
//                           className="cursor-pointer border-none p-0.5 bg-transparent"
//                           onClick={() => inputRef.current.click()}
//                         >
//                           <DragAndDropIcon />
//                         </button>
//                         <p>Drag and drop or select from your device</p>
//                       </div>
//                     )}
//                   </label>
//                   {dragActive && (
//                     <div
//                       className="absolute w-full h-full rounded top-0 right-0 left-0 bottom-0"
//                       onDragEnter={handleDrag}
//                       onDragLeave={handleDrag}
//                       onDragOver={handleDrag}
//                       onDrop={handleDrop}
//                     ></div>
//                   )}

//                   <div className="flex items-center justify-between mt-6">
//                     <button
//                       className="px-14 py-1 rounded bg-enabled-btn text-white"
//                       onClick={onButtonClick}
//                       type="button"
//                     >
//                       Complete sign up
//                     </button>

//                     <Link
//                       to={"/verifyEmail"}
//                       className="flex items-center text-enabled-btn text-xs"
//                     >
//                       skip <SkipIcon className="pl-1" />
//                     </Link>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </section>
//       </section>
//     </main>
//   );
// };

// export default UploadLogo;

// YOUR CODE UNTOUCHED
// import React, { useState, useRef } from "react";
// import { Link } from "react-router-dom";
// import CustomButton from "../common/CustomButton";
// import CustomizableAvatar from "../common/CustomizableAvatar";
// import MainAvatar from "../../assets/main-avatar.png";
// import Smartlend from "../../assets/SMARTLEND.png";
// import { DragAndDropIcon, SkipIcon } from "../common/IconComponents";
// import axios from "axios";

// const UploadLogo = () => {
//   const [dragActive, setDragActive] = useState(false);
//   const [uploadedImage, setUploadedImage] = useState(null);
//   const inputRef = useRef(null);

//   const handleDrag = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     if (e.type === "dragenter" || e.type === "dragover") {
//       setDragActive(true);
//     } else if (e.type === "dragleave") {
//       setDragActive(false);
//     }
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setDragActive(false);
//     if (e.dataTransfer.files && e.dataTransfer.files[0]) {
//       handleFile(e.dataTransfer.files);
//     }
//   };

//   const handleChange = (e) => {
//     e.preventDefault();
//     if (e.target.files && e.target.files[0]) {
//       handleFile(e.target.files);
//     }
//   };

//   const onButtonClick = () => {
//     inputRef.current.click();
//   };

//   const handleFile = (files) => {
//     const file = files[0];

//     // Create a FormData object
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("upload_preset", "eqprvodt");

//     // Make an HTTP request to Cloudinary using Axios
//     axios
//       .post("https://api.cloudinary.com/v1_1/darnus3nl/image/upload", formData)
//       .then((response) => {
//         // Handling response from Cloudinary
//         console.log(response.data);
//         // Extracting image URL from the response
//         const imageUrl = response.data.secure_url;
//         setUploadedImage(imageUrl);
//       })
//       .catch((error) => {
//         console.error("Error uploading image to Cloudinary: ", error);
//       });
//   };

//   return (
//     <main>
//       <section className="container my-0 mx-auto">
//         <section>
//           <CustomizableAvatar
//             src={Smartlend}
//             avatarClass="lg:hidden my-0 mx-auto py-2"
//           />
//           <div className="p-4 px-4 md:p-8">
//             <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
//               <CustomizableAvatar
//                 src={MainAvatar}
//                 customClass="px-1 lg:min-h-max"
//               />

//               <div className="px-10 lg:col-span-2 py-5">
//                 <CustomizableAvatar
//                   src={Smartlend}
//                   avatarClass="hidden lg:block text-2xl"
//                 />
//                 <p className="text-xl sm:text-2xl font-medium py-6">
//                   Upload company logo
//                 </p>
//                 <p>
//                   Give your workspace a more pleasing feel with your company
//                   logo
//                 </p>

//                 <form
//                   id="form-file-upload"
//                   onDragEnter={handleDrag}
//                   onSubmit={(e) => e.preventDefault()}
//                   className="w-9/12 pt-4"
//                 >
//                   <input
//                     ref={inputRef}
//                     type="file"
//                     id="input-file-upload"
//                     multiple={false}
//                     onChange={handleChange}
//                     className="hidden"
//                   />
//                   <label
//                     id="label-file-upload"
//                     htmlFor="input-file-upload"
//                     className={`flex items-center justify-center h-full border rounded bg-th-bg text-center py-11 px-8 ${
//                       dragActive ? "bg-white" : ""
//                     }`}
//                   >
//                     {uploadedImage ? (
//                       <img
//                         src={uploadedImage}
//                         alt="Uploaded"
//                         className="max-h-64 max-w-full"
//                       />
//                     ) : (
//                       <div>
//                         <button
//                           className="cursor-pointer border-none p-0.5 bg-transparent"
//                           onClick={onButtonClick}
//                         >
//                           <DragAndDropIcon />
//                         </button>
//                         <p>Drag and drop or select from your device</p>
//                       </div>
//                     )}
//                   </label>
//                   {dragActive && (
//                     <div
//                       className="absolute w-full h-full rounded top-0 right-0 left-0 bottom-0"
//                       onDragEnter={handleDrag}
//                       onDragLeave={handleDrag}
//                       onDragOver={handleDrag}
//                       onDrop={handleDrop}
//                     ></div>
//                   )}

//                   <div className="flex items-center justify-between mt-6">
//                     <CustomButton className="bg-enabled-btn text-white">
//                       <Link to={"/verifyEmail"} className="px-14">
//                         Complete sign up
//                       </Link>
//                     </CustomButton>
//                     <Link
//                       to={"/verify email"}
//                       className="flex items-center text-enabled-btn text-xs"
//                     >
//                       skip <SkipIcon className="pl-1" />
//                     </Link>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </section>
//       </section>
//     </main>
//   );
// };

// export default UploadLogo;



